exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TeamChip__gameScoreRow--vEOBX {\n  display: flex;\n}\n\n.TeamChip__teamLogo--24d3w {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding-right: 8px;\n}\n.TeamChip__teamLogo--24d3w img {\n  width: 20px;\n}\n\n.TeamChip__teamName--yhY0n {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.TeamChip__defaultLogo--3ZDvo {\n  border: 2px solid #000;\n  border-radius: 50%;\n  box-sizing: border-box;\n  background-color: #1e1f21;\n  width: 20px;\n  height: 20px;\n}", ""]);

// exports
exports.locals = {
	"gameScoreRow": "TeamChip__gameScoreRow--vEOBX",
	"teamLogo": "TeamChip__teamLogo--24d3w",
	"teamName": "TeamChip__teamName--yhY0n",
	"defaultLogo": "TeamChip__defaultLogo--3ZDvo"
}; 
var style = module.exports.toString();module.exports = exports.locals || { stylesheet: "" };if (!module.exports.stylesheet) { module.exports.stylesheet = style; };